var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        fullscreen: "",
        "custom-title": _vm.dialogTitle,
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "formGroup",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "small",
            inline: "",
            "label-position": "top",
          },
        },
        [
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "1." + _vm.$t("storeVisitReport.common.basicInfo"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "rtlFullName",
                        rules: _vm.rules.validateIpt.concat(_vm.rules.iptEmpty),
                        label: _vm.$t("storeVisitReport.basic.storeName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.rtlFullName,
                          maxlength: 50,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "rtlFullName", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "PCD",
                        rules: _vm.rules.chooseEmpty,
                        label: _vm.$t(
                          "storeVisitReport.basic.provinceCityDistrict"
                        ),
                      },
                    },
                    [
                      _c("FormCascader", {
                        attrs: {
                          "target-form": _vm.form,
                          "key-list": [
                            "rtlRegion",
                            "rtlRegionCode",
                            "rtlCity",
                            "rtlCityCode",
                            "rtlDistrict",
                            "rtlDistrictCode",
                          ],
                          mode: _vm.mode,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "rtlAddress",
                        rules: _vm.rules.validateIpt.concat(_vm.rules.iptEmpty),
                        label: _vm.$t("storeVisitReport.basic.address"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.rtlAddress,
                          maxlength: 100,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "rtlAddress", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "contactsNameOne",
                        rules: _vm.rules.validateIpt.concat(_vm.rules.iptEmpty),
                        label: _vm.$t("storeVisitReport.basic.contact1"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsNameOne,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "contactsNameOne", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "contactsMobileOne",
                        rules: _vm.rules.phoneEmpty.concat(
                          _vm.rules.validatePhone
                        ),
                        label: _vm.$t("storeVisitReport.basic.cellPhone1"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsMobileOne,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "contactsMobileOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "2." + _vm.$t("storeVisitReport.common.moreInfo"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.contact2"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsNameTwo,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "contactsNameTwo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "contactsMobileTwo",
                        rules: _vm.rules.validatePhone,
                        label: _vm.$t("storeVisitReport.more.cellPhone2"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsMobileTwo,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "contactsMobileTwo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.contact3"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsNameThree,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "contactsNameThree",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "contactsMobileThree",
                        rules: _vm.rules.validatePhone,
                        label: _vm.$t("storeVisitReport.more.cellPhone3"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.contactsMobileThree,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "contactsMobileThree",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "3." + _vm.$t("storeVisitReport.common.RSSAS"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.carTRHistory"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.customerTireBizYear,
                          max: 9999,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "customerTireBizYear",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.carTAForTotal"),
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.customerTireSob,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form,
                                "customerTireSob",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.AvMSalesOfTires"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.monthTireSalesAvg,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "monthTireSalesAvg",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("storeVisitReport.RSSAS.RSS") } },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeStructure,
                          options: _vm.optConfig.storeStructureOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "storeStructure", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.employeeCount"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: { val: _vm.form.staff, mode: _vm.mode },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "staff", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.retailShare"),
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.retailShare,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(_vm.form, "retailShare", $event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.maxSalesBrand"),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.maxSalesBrand,
                          options: _vm.optConfig.ssbtypeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "maxSalesBrand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.maxSalesQty"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          max: 9999999,
                          val: _vm.form.maxSalesQty,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "maxSalesQty", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.gySalesQty"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          max: 9999999,
                          val: _vm.form.gySalesQty,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "gySalesQty", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "4." + _vm.$t("storeVisitReport.common.storeSInfo"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        rules: _vm.rules.validateIpt.concat(_vm.rules.iptEmpty),
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.shopSignBrand"
                        ),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.signBoardBrand,
                          options: _vm.optConfig.ssbtypeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "signBoardBrand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.installationDate"
                        ),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.installationDate,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "installationDate",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.storeSInfo.expiryDate"),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: { val: _vm.form.dueTime, mode: _vm.mode },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "dueTime", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.otherBrands"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.otherBrand,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "otherBrand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.storefrontPic"
                        ),
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.photo1,
                          "upload-params": _vm.uploadParams,
                          mode: "view",
                        },
                        on: {
                          "update:fileUrl": function ($event) {
                            return _vm.$set(_vm.form, "photo1", $event)
                          },
                          "update:file-url": function ($event) {
                            return _vm.$set(_vm.form, "photo1", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.displayPic1"
                        ),
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.photo2,
                          "upload-params": _vm.uploadParams,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:fileUrl": function ($event) {
                            return _vm.$set(_vm.form, "photo2", $event)
                          },
                          "update:file-url": function ($event) {
                            return _vm.$set(_vm.form, "photo2", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.displayPic2"
                        ),
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.photo3,
                          "upload-params": _vm.uploadParams,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:fileUrl": function ($event) {
                            return _vm.$set(_vm.form, "photo3", $event)
                          },
                          "update:file-url": function ($event) {
                            return _vm.$set(_vm.form, "photo3", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "5." + _vm.$t("storeVisitReport.common.storeMS"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.common.project"),
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("storeVisitReport.storeMS.tire"))),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siBalance"),
                        },
                        model: {
                          value: _vm.form.siBalance,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siBalance", $$v)
                          },
                          expression: "form.siBalance",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siWheelPosition"
                          ),
                        },
                        model: {
                          value: _vm.form.siWheelPosition,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siWheelPosition", $$v)
                          },
                          expression: "form.siWheelPosition",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siTireRepair"
                          ),
                        },
                        model: {
                          value: _vm.form.siTireRepair,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siTireRepair", $$v)
                          },
                          expression: "form.siTireRepair",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siValve"),
                        },
                        model: {
                          value: _vm.form.siValve,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siValve", $$v)
                          },
                          expression: "form.siValve",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("storeVisitReport.storeMS.nonTire"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siEngineOil"),
                        },
                        model: {
                          value: _vm.form.siEngineOil,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siEngineOil", $$v)
                          },
                          expression: "form.siEngineOil",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siBrake"),
                        },
                        model: {
                          value: _vm.form.siBrake,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siBrake", $$v)
                          },
                          expression: "form.siBrake",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siFacialClean"
                          ),
                        },
                        model: {
                          value: _vm.form.siFacialClean,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siFacialClean", $$v)
                          },
                          expression: "form.siFacialClean",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siPerishableGoods"
                          ),
                        },
                        model: {
                          value: _vm.form.siPerishableGoods,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siPerishableGoods", $$v)
                          },
                          expression: "form.siPerishableGoods",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.storeMS.otherService"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.siOther,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "siOther", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.storeSInfo.siMain"),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.siMain,
                          options: _vm.optConfig.mainserviceOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "siMain", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.siMainPercentage"
                        ),
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.siMainPercentage,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form,
                                "siMainPercentage",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "6." + _vm.$t("storeVisitReport.common.facAEq"),
                "default-open": true,
              },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: { label: _vm.$t("storeVisitReport.facAEq.area") },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.area,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(_vm.form, "area", $event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("㎡")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.facAEq.stationsCount"),
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: { val: _vm.form.workingBay, mode: _vm.mode },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "workingBay", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.facAEq.accountingMethod"
                        ),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.accountingMethod,
                          options: _vm.optConfig.daMethodOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form,
                              "accountingMethod",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-checkbox-group" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.facAEq.instoreFac"),
                      },
                    },
                    [
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.toilet"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.laundry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "laundry", $$v)
                          },
                          expression: "form.laundry",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.facAEq.customerLounge"
                          ),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.restRoom,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "restRoom", $$v)
                          },
                          expression: "form.restRoom",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.facAEq.wheelAlignment"
                          ),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.alignment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "alignment", $$v)
                          },
                          expression: "form.alignment",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.tireMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.fitting,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "fitting", $$v)
                          },
                          expression: "form.fitting",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.DBMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.balancing,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "balancing", $$v)
                          },
                          expression: "form.balancing",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.liftMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.liftingMachine,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "liftingMachine", $$v)
                          },
                          expression: "form.liftingMachine",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "7." + _vm.$t("storeVisitReport.step.sales"),
                "default-open": true,
              },
            },
            [
              _c(
                "el-table",
                {
                  staticClass: "m-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.form.tireSalesInfos,
                    border: "",
                    "show-summary": "",
                    "summary-method": _vm.getSummaries,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      index: _vm.tableIndex,
                      label: _vm.$t(
                        "retailStoresInfo.form.otherBrandSales.systemPk"
                      ),
                      width: "120",
                      align: "left",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tireBrand",
                      label: _vm.$t("storeVisitReport.SSTable.tireBrand"),
                      width: "180",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tireSupplier",
                      label: _vm.$t("storeVisitReport.SSTable.mainChannel"),
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "u-formItem",
                                attrs: {
                                  prop:
                                    "tireSalesInfos." +
                                    scope.$index +
                                    ".tireSupplier",
                                },
                              },
                              [
                                _c("FormSelect", {
                                  attrs: {
                                    val: scope.row.tireSupplier,
                                    options: _vm.optConfig.tireSupplierOptions,
                                    mode: _vm.mode,
                                  },
                                  on: {
                                    "update:val": function ($event) {
                                      return _vm.$set(
                                        scope.row,
                                        "tireSupplier",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("storeVisitReport.SSTable.payway"),
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "u-formItem",
                                attrs: {
                                  prop:
                                    "tireSalesInfos." +
                                    scope.$index +
                                    ".paymentTerms",
                                },
                              },
                              [
                                _c("FormSelect", {
                                  attrs: {
                                    val: scope.row.paymentTerms,
                                    options: _vm.optConfig.accountMethodOptions,
                                    mode: _vm.mode,
                                  },
                                  on: {
                                    "update:val": function ($event) {
                                      return _vm.$set(
                                        scope.row,
                                        "paymentTerms",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "monthlyAvgSales",
                      label: _vm.$t("storeVisitReport.SSTable.AMSales"),
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "u-formItem",
                                attrs: {
                                  prop:
                                    "tireSalesInfos." +
                                    scope.$index +
                                    ".monthlyAvgSales",
                                },
                              },
                              [
                                _c("FormInputNumber", {
                                  attrs: {
                                    val: scope.row.monthlyAvgSales,
                                    step: 1,
                                    mode: _vm.mode,
                                  },
                                  on: {
                                    "update:val": function ($event) {
                                      return _vm.$set(
                                        scope.row,
                                        "monthlyAvgSales",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stock",
                      label: _vm.$t("storeVisitReport.SSTable.stock"),
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "u-formItem",
                                attrs: {
                                  prop:
                                    "tireSalesInfos." + scope.$index + ".stock",
                                },
                              },
                              [
                                _c("FormInputNumber", {
                                  attrs: {
                                    val: scope.row.stock,
                                    step: 1,
                                    mode: _vm.mode,
                                  },
                                  on: {
                                    "update:val": function ($event) {
                                      return _vm.$set(
                                        scope.row,
                                        "stock",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tyreEighteenGreater" }, [
                _c("div", { staticClass: "tyreEighteenGreater-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "retailStoresInfo.form.otherBrandSales.tyreEighteenGreater"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "u-iptItem",
                        attrs: {
                          prop: "tyreEighteenGreater",
                          rules: _vm.rules.validatePatts,
                        },
                      },
                      [
                        _c(
                          "FormInputNumber",
                          {
                            staticClass: "tyreEighteenGreater-input",
                            attrs: {
                              val: _vm.form.tyreEighteenGreater,
                              max: 100,
                              step: 0.01,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "tyreEighteenGreater",
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "append" }, slot: "append" },
                              [_vm._v("%")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }